const runtimeOverride = (window as any).__API_URL__ || localStorage.getItem("API_URL_OVERRIDE");
const rawEnvUrl = import.meta.env.VITE_API_URL as string | undefined;
const fallbackLocal = "http://127.0.0.1:8000";

const pickUrl = () => {
  if (runtimeOverride) return runtimeOverride;
  if (rawEnvUrl && rawEnvUrl !== "undefined") return rawEnvUrl;
  return fallbackLocal;
};

const normalizedRaw = pickUrl();
export const API_URL = normalizedRaw.endsWith("/") ? normalizedRaw.slice(0, -1) : normalizedRaw;
console.info("[config] API_URL em uso:", API_URL);
